import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AsvConsultationChecklistDetailLineModel } from '../../../../../models/aggregates/asv/asv-consultation-checklist-detail-line.model';
import {ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config} from '../../api-services';

@Injectable({
  providedIn: 'root'
})
export class AsvConsultationChecklistDetailLineService extends BaseApiTemplateService<AsvConsultationChecklistDetailLineModel> {

    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.ASV_PREFIX + 'consultation-checklist-detail-line';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ASV_PREFIX + 'consultation-checklist-detail-line/backoffice-ep';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ASV_PREFIX + 'consultation-checklist-detail-line/backoffice-ep';
        this.httpClient = http;
      }
}
